export default function CTASection() {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden bg-foreground-950">
      {/* Animated gradient background */}
      <div className="absolute inset-0">
        <div
          className="absolute inset-0 opacity-30"
          style={{
            background: "linear-gradient(135deg, oklch(var(--primary-800)) 0%, oklch(var(--accent-700)) 50%, oklch(var(--primary-800)) 100%)",
            backgroundSize: "400% 400%",
            animation: "gradientShift 15s ease infinite",
          }}
        />
        <style>{`
          @keyframes gradientShift {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
        `}</style>
      </div>

      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: "radial-gradient(circle, oklch(var(--accent-500)) 1px, transparent 1px)",
          backgroundSize: "32px 32px"
        }} />
      </div>

      <div className="relative mx-auto max-w-4xl px-4 md:px-6 text-center">
        <div className="flex justify-center">
          <div className="inline-flex items-center gap-2 rounded-full border border-accent-500/30 bg-accent-500/10 px-3 py-1 text-xs font-medium text-accent-400">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-400" />
            Vamos resolver hoje
          </div>
        </div>
        <h2 className="mt-5 text-4xl md:text-5xl lg:text-6xl font-semibold text-background-50 leading-[1.05] font-heading">
          Seu certificado digital pode ser <span className="text-gradient-green">resolvido hoje</span>
        </h2>
        <p className="mt-6 text-lg text-background-50/75 max-w-2xl mx-auto">
          Evite atraso em nota fiscal, acesso bloqueado em sistemas e correria de última hora. Fale agora com a AVcertifica e emita ou renove seu certificado digital com atendimento simples, seguro e online.
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-3">
          <a
            href="https://wa.me/5547991891311"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-7 py-4 text-primary-950 font-medium hover:bg-background-50 transition-colors whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-lg"></i>
            Falar com a AVcertifica no WhatsApp
          </a>
          <a
            href="https://wa.me/5547991891311"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/5 backdrop-blur px-7 py-4 text-background-50 font-medium hover:bg-background-50/10 transition-colors whitespace-nowrap"
          >
            <i className="ri-refresh-line"></i>
            Renovar certificado vencido
          </a>
        </div>
      </div>
    </section>
  );
}